import { render, staticRenderFns } from "./AutoPostBoosting.vue?vue&type=template&id=4a9ce998&scoped=true&"
import script from "./AutoPostBoosting.vue?vue&type=script&lang=ts&"
export * from "./AutoPostBoosting.vue?vue&type=script&lang=ts&"
import style0 from "./AutoPostBoosting.vue?vue&type=style&index=0&id=4a9ce998&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9ce998",
  null
  
)

export default component.exports